import { Link, useLocation, type Location } from "react-router-dom";
import { Home } from "lucide-react";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./ui/breadcrumb";

interface BreadcrumbItemData {
  label: string;
  path: string;
  isActive?: boolean;
}

const Breadcrumbs = () => {
  const mainLocation = useLocation();
  const backgroundLocation = mainLocation.state?.background as
    | Location
    | undefined;
  const location = backgroundLocation ?? mainLocation;

  const generateBreadcrumbs = (): BreadcrumbItemData[] => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const breadcrumbs: BreadcrumbItemData[] = [];

    if (pathSegments.length > 0) {
      let currentPath = "";

      pathSegments.forEach((segment, index) => {
        currentPath += `/${segment}`;
        let label = "";

        /**@todo make breadcrumbs route-aware */
        if (segment === "system-status" && index === 0) {
          label = "System Status";
        } else if (segment === "accounts" && index === 0) {
          label = "Accounts";
        } else if (segment === "properties" && index === 0) {
          label = "Properties";
        } else {
          label = decodeURIComponent(segment);
        }

        breadcrumbs.push({
          label,
          path: currentPath,
          isActive: currentPath === mainLocation.pathname,
        });
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  return (
    <div className="p-4">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <Home className="h-4 w-4" />
          </BreadcrumbItem>
          {breadcrumbs.map((crumb, index) => (
            <div key={crumb.path} className="contents">
              {index > 0 && <BreadcrumbSeparator />}
              <BreadcrumbItem>
                {crumb.isActive ? (
                  <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.path}>{crumb.label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </div>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default Breadcrumbs;
